<template>
  <div class="iDalgo-Card-Min" :class="{ 'active': active, 'disabled': disabled }">
    <div class="iDalgo-Card-Min__Picture" :style="{ 'background-image': 'url(' + picture + ')' }">
      <div class="iDalgo-Card-Min__Picture__Whitemark">
        <svgicon name="logo" :original="true"></svgicon>
      </div>
      <div v-show="percent !== null" class="iDalgo-Card-Min__Picture__Stat">{{ stat }}</div>
    </div>
    <div class="iDalgo-Card-Min__Content">
      <h4>{{ title }}</h4>
    </div>
  </div>
</template>

<script>
import '@/components/icons'
export default {
  name: 'iDalgo-Card-Min',
  props: {
    picture: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    percent: {
      type: Number
    },
    active: {
      type: Boolean
    }
  },
  computed: {
    stat () {
      return `${this.percent}%`
    }
  }
}
</script>

<style lang="scss">
.iDalgo-Card-Min {
  display: flex;
  flex-flow: column;
  padding: 0;
  border-radius: 3px;
  width: 80px;
  height: 112px;
  box-shadow: 0 2px 9px 0 rgba(0,0,0,0.22);
  overflow: hidden;
  flex-grow: 0;
  margin: 8px;
  transition: all 0.2s;
  cursor: default;

  &__Picture {
    display: flex;
    padding: 0;
    margin: 0;
    background: #fff center center no-repeat;
    background-size: cover;
    width: 100%;
    height: calc(112px - 30px);
    transition: all 0.2s;
    position: relative;

    &__Whitemark {
      position: absolute;
      top: 0;
      left: 0;
      width: 23px;
      height: 23px;
      background-color: $color2;
      border-radius: 0 0 6px 0;
      opacity: 0;
      transition: all 0.2s;
      display: none; // TODO: remove after Euro
      justify-content: center;
      align-items: center;

      svg {
        width: 8px;
      }
    }

    &__Stat {
      position: absolute;
      top: 0;
      right: 0;
      min-width: 30px;
      height: 23px;
      border-radius: 0 0 0 3px;
      color: #fff;
      background: #FC5200;
      font-size: 12px;
      font-weight: 600;
      font-family: "source_sans_proregular", sans-serif;
      line-height: 23px;
      text-align: center;
    }
  }

  &__Content {
    padding: 5px;
    background: #fff;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    transition: all 0.2s;
    overflow: hidden;
    min-height: 30px;
    box-sizing: border-box;

    h4 {
      color: lighten(#000, 20%);
      margin: 0;
      padding: 0;
      font-family: "source_sans_prolight", sans-serif;
      font-size: 12px;
      line-height: 12px;
      text-align: center;
      transition: all 0.2s;
    }
  }

  &.disabled {
    opacity: 0.4 !important;
    cursor: not-allowed;
  }

  &:hover {
    box-shadow: 0 4px 35px 0 rgba(0,0,0,0.22);
  }

  &.active {
    opacity: 1;
    box-shadow: 0 4px 35px 0 rgba(0,0,0,0.22);
    .iDalgo-Card-Min__Content {
      background-color: $color3;
      h4, b {
        color: lighten(#000, 20%);
      }
    }

    .iDalgo-Card-Min__Picture__Whitemark {
      opacity: 1;
    }
  }

  @media (min-width: 360px) and (max-width: 450px) {
    margin: 6px 4px;
    width: 75px;

    &:nth-of-type(4n + 1) {
      margin-left: 0;
    }
    &:nth-of-type(4n) {
      margin-right: 0;
    }
  }

  @media (max-width: 360px) {
    margin: 6px 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/iDalgo-Card-Min.vue